import { Injectable } from '@angular/core';

//enums
import { OSEnum } from 'src/app/shared/enums';

declare const window: any;

@Injectable({
  providedIn: 'root'
})
export class CommonHelper {

  constructor() { }

  public static get mobileOperatingSystem() {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;

    if (/windows phone/i.test(userAgent)) {
      return OSEnum.windowsPhone;
    }

    if (/android/i.test(userAgent)) {
      return OSEnum.android;
    }

    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return OSEnum.ios;
    }

    return OSEnum.none;
  }
}